import { useState, useEffect } from 'react';
import { Box, FormControl, makeStyles, Select, MenuItem, TextField, InputAdornment, Typography } from '@material-ui/core';

export const OPTION_TYPE = [
    {
        name: "Derecha",
        key: '0'
    },
    {
        name: "Izquierda",
        key: '1'
    },
]

const useStyles = makeStyles(theme => ({
    devicesLabel: {
        color: 'rgba(0, 0, 0, 0.54)',
        fontSize: '0.75rem',
    },
    input: {
        '& .MuiInputBase-input': {
            // Saco las flechitas al input type number
            '&::-webkit-inner-spin-button': {
                webkitAppearance: "none",
                mozAppearance: "none",
                appearance: " none",
                margin: 0
            },
        },
    },
}));

const BlshFilterOptions = ({ varState, setVarState, blockNodeSettings }) => {
    const [stateForm, setStateForm] = useState({})
    const classes = useStyles();

    useEffect(() => {
        if (varState?.a) {
            setStateForm(varState?.a)
        }
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        setVarState({
            ...varState,
            a: stateForm
        })
        // eslint-disable-next-line
    }, [stateForm])

    const handleChange = (e) => {
        let value = e.target.value
        let name = e.target.name
        setStateForm({
            ...stateForm,
            [name]: value
        })
    }

    return (
        <Box>
            <>
                {
                    (Array.isArray(blockNodeSettings?.atributes_keys) ? blockNodeSettings?.atributes_keys : []).map((element, indx) => {
                        return (
                            <Box key={indx} >
                                {element.key === 'd' ?
                                    <Box>
                                        <Box display="flex" alignItems="center" flexWrap="wrap" >
                                            <Box className={classes.devicesLabel}>
                                                {element.name}
                                            </Box>
                                        </Box>
                                        <Box width={'100%'}>
                                            <FormControl fullWidth>
                                                <Select
                                                    name={element.key}
                                                    value={stateForm?.[element.key] ? stateForm?.[element.key] : ''}
                                                    onChange={handleChange}
                                                >
                                                    {OPTION_TYPE.map((elem, indx) => (
                                                        <MenuItem
                                                            key={indx}
                                                            value={elem.key}
                                                        >
                                                            {elem.name}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Box>
                                    </Box>
                                    :
                                    < Box width={'100%'} mt={2} className={classes.input}>
                                        <TextField
                                            fullWidth
                                            type='number'
                                            name={element.key}
                                            label={element.name}
                                            size="small"
                                            variant="outlined"
                                            value={stateForm?.[element.key] ?? ''}
                                            onChange={handleChange}
                                            color="primary"
                                            InputProps={{
                                                startAdornment: element.key === 'o' && (
                                                    <InputAdornment position="start" style={{ marginRight: 0 }}>
                                                    </InputAdornment>
                                                )
                                            }}
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    </Box>
                                }
                            </Box>
                        )
                    })
                }
            </>
        </Box >
    );
}

export default BlshFilterOptions;



